import { Box } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { RichTextEditor } from '@flecto/ui'

import { useFormContext } from './FormCustomer'

export function Notes() {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const form = useFormContext()
  return (
    <Box mb='lg'>
      <RichTextEditor
        label={t('add_customer.notes')}
        placeholder={t('add_customer.notes_description')}
        {...form.getInputProps('notes')}
      />
    </Box>
  )
}
